import beaker from "../asstes/icons/chemistry/beaker.svg";
import bottle from "../asstes/icons/chemistry/bottle.svg";
import bubblesSvg from "../asstes/icons/chemistry/bubbles.svg";
import crystal from "../asstes/icons/chemistry/crystal.svg";
import droplet from "../asstes/icons/chemistry/droplet.svg";
import fireSvg from "../asstes/icons/chemistry/fire.svg";
import flask from "../asstes/icons/chemistry/flask.svg";
import hourglass from "../asstes/icons/chemistry/hourglass.gif";
import ingot from "../asstes/icons/chemistry/ingot.svg";
import powder from "../asstes/icons/chemistry/powder.svg";
import lowtemp from "../asstes/icons/chemistry/low-temperature.gif";
import energy from "../asstes/icons/chemistry/energy.svg";
import fireGif from "../asstes/icons/chemistry/fireGif.gif";
import smokeGif from "../asstes/icons/chemistry/smoke.gif";
import bubblesGif from "../asstes/icons/chemistry/bubbles.gif";

export const CHEMISTRY_ICONS = {
  beaker,
  flask,
  bottle,
  droplet,
  ingot,
  powder,

  // Effects (normalized keys)
  bubbles: bubblesSvg,
  bubblesGif,
  fire: fireSvg,
  fireGif,
  smoke: smokeGif,
  crystal,
  lowtemp,

  // Reaction states
  hourglass,
  energy,
};
